import classNames from 'classnames'
import { useQuery } from '@tanstack/react-query'
import { registryPath } from 'lib/urls'
import { track } from 'lib/analytics'
import Slide from '../../components/slide/slide'
import { RegItemPreviewGrid } from './components/RegItemPreviewGrid'
import { CloneButton } from './components/CloneButton'
import { fetchTemplates } from '../../api'
import css from './styles.scss'
import { useParams } from 'react-router-dom-v5-compat'

const PreviewTemplate = ({ currentRegistry }: any) => {
  // Get params from router + redux state
  const { id: templateId } = useParams() as { id: string }
  const currentRegistryId = currentRegistry?.id

  // Fetch template data
  const { isLoading, data } = useQuery({
    queryKey: [templateId],
    queryFn: () => fetchTemplates(templateId),
    refetchOnWindowFocus: false,
  })

  const regItems = data?.template?.items ?? []
  const template = data?.template ?? {}

  const navigateToRegistry = () => {
    window.location.href = registryPath(currentRegistry.urlSlug, {
      confetti: true,
    })
  }

  return (
    <>
      <Slide>
        <div className="h2 text-bold">{template?.title}</div>
        <div className="h5 mtn mbxl text-muted">{template?.description}</div>
        <RegItemPreviewGrid regItems={regItems} />
        {/* Whitespace to account for ctaBar overlay */}
        <div style={{ height: 200 }} />
      </Slide>
      {!isLoading && data && (
        <div
          className={classNames(
            css.ctaBar,
            'animated fadeIn animate-250ms delay-850ms'
          )}
        >
          <CloneButton
            ctaText="Use This Sample Registry"
            destinationRegistryId={currentRegistryId}
            registryTemplateTitle={template?.title}
            registryTemplateType={track.RegistryTemplateType.REG_TEMPLATE}
            sourceTemplateId={templateId}
            onSubmitSuccess={navigateToRegistry}
          />
        </div>
      )}
    </>
  )
}

export default PreviewTemplate
